import React, { createContext, useContext, useState, useEffect } from 'react';
import translations from './translations';

const LanguageContext = createContext();

export function LanguageProvider({ children, initialLanguage = 'en' }) {
  const [language, setLanguage] = useState(
    localStorage.getItem('veyl_language') || initialLanguage
  );

  useEffect(() => {
    localStorage.setItem('veyl_language', language);
  }, [language]);

  const t = (key, vars = {}) => {
    const lang = translations[language] || translations['en'];
    let str = lang[key] || translations['en'][key] || key;
    Object.entries(vars).forEach(([k, v]) => {
      str = str.replace(`{${k}}`, v);
    });
    return str;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}